<template>
  <HeadlineComponent>Konfiguration</HeadlineComponent>
  <Form
    class="form-horizontal"
    @submit="onSubmit"
    :initialValues="cfg"
    v-if="loaded"
  >
    <h2>Benachrichtigungs Einstellungen</h2>
    <div class="form-group">
      <label for="shift_cancel_notification_time" class="control-label"
        >Benachrichtigung für abgesagte Schichten per SMS an Teamleads</label
      >
      <div class="input-group">
        <BootstrapField
          type="number"
          name="shift_cancel_notification_time"
          min="-1"
          step="1"
        />
        <div class="input-group-append input-group-text">Tage vorher</div>
      </div>
      <small class="form-text"
        >-1 = Keine Benachrichtigung und 0 = Benachrichtigung sofort</small
      >
    </div>
    <div class="form-group">
      <label for="shift_reminder_notification_time" class="control-label"
        >Erinnerung per SMS an Crewmitglieder vor Schichtbeginn</label
      >
      <div class="input-group">
        <BootstrapField
          type="number"
          name="shift_reminder_notification_time"
          min="-1"
          step="1"
        />
        <div class="input-group-append input-group-text">Minuten vorher</div>
      </div>
      <small class="form-text">-1 = Keine Benachrichtigung</small>
    </div>
    <div class="form-group" v-if="ticketing_enabled">
      <label for="arrive_notification_time" class="control-label"
        >Benachrichtigung vor einer Schicht bevor Crew bei der Rezeption
        war</label
      >
      <div class="input-group">
        <BootstrapField
          type="number"
          name="arrive_notification_time"
          min="-1"
          step="1"
        />
        <div class="input-group-append input-group-text">Stunden vorher</div>
      </div>
      <small class="form-text">-1 = Keine Benachrichtigung</small>
    </div>
    <div class="form-group">
      <div class="form-check">
        <Field
          type="checkbox"
          name="notify_on_force_assign"
          class="form-check-input"
          id="notify_on_force_assign"
          :value="true"
        />
        <label class="form-check-label" for="notify_on_force_assign">
          Die Crew per SMS benachrichtigen wenn sie von einem Teamlead / Admin
          in eine Schicht eingetragen werden
        </label>
      </div>
    </div>
    <div class="form-group">
      <div class="form-check">
        <Field
          type="checkbox"
          name="shift_cancel_admin_notification"
          class="form-check-input"
          id="shift_cancel_admin_notification"
          :value="true"
        />
        <label class="form-check-label" for="shift_cancel_admin_notification">
          Zusätzlich zu Teamleads sollen die Schichtabsagen SMS auch an Admins
          gesendet werden
        </label>
      </div>
    </div>
    <h2>Texte</h2>
    <div class="form-group">
      <QuillField name="login_text" label="Login Text" />
    </div>
    <div class="form-group">
      <QuillField name="registration_text" label="Registierungs Text" />
    </div>
    <div class="form-group">
      <QuillField name="dashboard_text" label="Startseiten Text" />
    </div>
    <h2>Shirts</h2>
    <div class="form-group">
      <div class="form-check">
        <Field
          type="checkbox"
          name="hide_tshirts"
          class="form-check-input"
          id="hide_tshirts"
          :value="true"
        />
        <label class="form-check-label" for="hide_tshirts">
          T-Shirt Auswahl verstecken
        </label>
      </div>
    </div>
    <h2>Registration</h2>
    <div class="form-group">
      <div class="form-check">
        <Field
          type="checkbox"
          name="registration_enabled"
          class="form-check-input"
          id="registration_enabled"
          :value="true"
        />
        <label class="form-check-label" for="registration_enabled">
          Die Crew kann sich selbst Registieren
        </label>
      </div>
    </div>
    <div class="form-group">
      <LoadingButton :loading="loading" class="btn-primary"
        >Speichern</LoadingButton
      >
    </div>
  </Form>
</template>

<script>
import { Field, Form } from "vee-validate";
import { mapActions, mapState } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import { useConfigStore } from "@/stores/config";
import LoadingButton from "@/components/LoadingButton.vue";
import QuillField from "../components/QuillField.vue";
import BootstrapField from "../components/BootstrapField.vue";
import { setErrors } from "@/helper/ErrorToActions.js";
import * as Sentry from '@sentry/vue';

export default {
  name: "UpdateConfigView",
  data() {
    return {
      cfg: {},
      loading: false,
      loaded: false,
    };
  },
  async beforeMount() {
    try {
      this.cfg = await this.getConfig();
      this.loaded = true;
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
        window.scrollTo(0, 0);
      }
    }
  },
  computed: {
    ...mapState(useConfigStore, ["ticketing_enabled"]),
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    ...mapActions(useConfigStore, { getConfig: "get", saveConfig: "save" }),
    async onSubmit(values, actions) {
      this.loading = true;
      try {
        await this.saveConfig(values);
        window.scrollTo(0, 0);
        this.addAlert("success", "Konfiguraton erfolgreich bearbeitet.");
      } catch (e) {
        if (e) {
          if (e.response.data && e.response.data.errors) {
            setErrors(e.response.data.errors, actions);
          }
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      this.loading = false;
    },
  },
  components: {
    HeadlineComponent,
    QuillField,
    // eslint-disable-next-line vue/no-reserved-component-names
    Form,
    Field,
    BootstrapField,
    LoadingButton,
  },
};
</script>

<style scoped></style>
